import useSWR from 'swr';

import axios, { endpoints } from 'src/lib/axios';

import { useAuthContext } from 'src/auth/hooks';

// Nº de "huecos de conocimiento" (preguntas con voto negativo agrupadas), para el badge del menú.
// El endpoint solo lo permite el rol Administrator, así que se omite la petición para el resto
// de roles (p.ej. Supervisor, que sí ve el resto de "Agente IA" pero no esta sección) y evita el 403.
export function useAgentKbGapCount() {
  const { isAdmin } = useAuthContext();

  const { data, mutate } = useSWR(
    isAdmin() ? endpoints.agentKbGap.count : null,
    async (url: string) => {
      const res = await axios.get(url);
      return (res.data?.count as number) ?? 0;
    },
    { revalidateOnFocus: false, refreshInterval: 120000 }
  );

  return { count: data ?? 0, refresh: mutate };
}
